import { FunctionComponent, ReactNode } from 'react';

import { FormControl, InputLabel, Select, MenuItem, FormHelperText, SelectChangeEvent } from '@mui/material';
import { RoleModel } from '@/modules/users/submodules/roles/types/RoleModel';
import { useRoles } from '../hooks/useRoles';
import { useTranslation } from '@/lib';

interface RoleSelectProps {
  selectedRoleId?: number;
  onChange: (selectedRole?: RoleModel) => void;
  helperText?: string;
}

const RoleSelect: FunctionComponent<RoleSelectProps> = ({ selectedRoleId, onChange, helperText }) => {
  const { t } = useTranslation();
  const { roles } = useRoles();

  function onRoleChanged(event: SelectChangeEvent<number>, child: ReactNode) {
    const selectedRole = roles.find((at) => at.dto.id === event.target.value);

    onChange(selectedRole);
  }
  return (
    <FormControl className="w-full">
      <InputLabel>{t('role')}</InputLabel>
      <Select value={selectedRoleId && roles.length > 0 ? selectedRoleId : ''} label={t('role')} onChange={onRoleChanged}>
        {roles.map((role) => {
          return (
            <MenuItem key={role.dto.id} value={role.dto.id}>
              {role.nameInTitleCase}
            </MenuItem>
          );
        })}
      </Select>
      {helperText && <FormHelperText>{helperText} </FormHelperText>}
    </FormControl>
  );
};

export default RoleSelect;
